module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_8023.69f8c741.png";